module.exports = __webpack_public_path__ + "img/gratification-success.be2a758f.svg";